export * from './categories';
export * from './search';

const LS_PREFIX = 'OSK_';

export const LS_KEY_WEB_TO_APP_GENDER_DIALOG = `${LS_PREFIX}WEB_TO_APP_GENDER_DIALOG`;
export const LS_KEY_WEB_TO_APP_DOWNLOAD_APP_DESKTOP_DIALOG = `${LS_PREFIX}WEB_TO_APP_DOWNLOAD_APP_DESKTOP_DIALOG`;
